import { defineStyleConfig, defineStyle } from "@chakra-ui/react";

// const solid = defineStyle({
//   fontSize: "15px",
//   fontWeight: 500,
//   px: 8,
//   // color: "background",
//   borderRadius: "6px",
// });
// const outline = defineStyle({
//   _hover: { bg: "par.50" },
// });

const cancel = defineStyle({
  background: "transparent",
  fontSize: "14px",
  fontWeight: 600,
  color: "gray.700",
  textDecoration: "underline",
  textUnderlineOffset: 2,
  textDecorationThickness: 1,
});

const yellow = defineStyle({
  background: "linear-gradient(180deg, #FEE586 0%, #EE8902 100%)",
  color: "#fff",
  borderBottom: "4px solid #6D2B04",
  rounded: "27px",
  _hover: {
    background: "linear-gradient(180deg, #FEE586 0%, #EE8902 100%)",
    _loading: {
      background: "linear-gradient(180deg, #FEE586 0%, #EE8902 100%)",
    },
    _disabled: {
      bg: "linear-gradient(180deg, #FEE586 0%, #EE8902 100%)",
    },
  },
  _loading: {
    _hover: {
      background: "linear-gradient(180deg, #FEE586 0%, #EE8902 100%)",
    },
  },
});

const blue = defineStyle({
  background: "brand.500",
  color: "#fff",
  borderBottom: "6px solid #1D86AF",
  rounded: "16px",
  _hover: {
    background: "hsl(197, 99%, 46%)",
    _loading: {
      background: "#F8D79E",
    },
    _disabled: {
      bg: "hsl(197, 99%, 48%)",
    },
  },
  _loading: {
    _hover: {
      background: "brand.600",
    },
  },
});

const purple = defineStyle({
  background: "#B333FB",
  color: "#fff",
  borderBottom: "6px solid	hsl(278, 96%, 49%)",
  rounded: "16px",
  _hover: {
    background: "hsl(278, 96%, 55%)",
    _loading: {
      background: "hsl(278, 96%, 63%)",
    },
    _disabled: {
      bg: "hsl(278, 96%, 50%)",
    },
  },
  _loading: {
    _hover: {
      background: "hsl(278, 96%, 63%)",
    },
  },
});

const red = defineStyle({
  background: "hsl(0, 70%, 56%)",
  color: "#fff",
  borderBottom: "6px solid hsl(0, 70%, 46%)",
  rounded: "16px",
  _hover: {
    background: "hsl(0, 70%, 53%)",
    _loading: {
      background: "hsl(0, 70%, 60%)",
    },
    _disabled: {
      bg: "hsl(0, 70%, 64%)",
    },
  },
  _loading: {
    _hover: {
      background: "hsl(0, 70%, 60%)",
    },
  },
});

const sm = defineStyle({
  fontSize: "12px",
  px: "4",
  h: { base: "10", md: "10" },
});
const normal = defineStyle({
  fontSize: { base: "16px", md: "14px" },
  px: "6",
  h: { base: "12", md: "12" },
});
const lg = defineStyle({
  fontSize: "18px",
  px: "9",
  h: { base: "14", md: "14" },
});

export const button = defineStyleConfig({
  baseStyle: {
    position: "relative",
    fontSize: "14px",
    fontWeight: 600,
    _active: {
      transform: "scale(0.98)",
      _disabled: {
        transform: "scale(1)",
      },
    },
    _loading: {
      bg: undefined,
      opacity: 0.8,
    },
    _after: {
      content: `" "`,
      position: "absolute",

      inset: 0,
      bg: "retransparentd",
      borderRadius: "16px",
      border: "4px solid",
      borderColor: "buttonborder",
    },

    transition: "all 0.15s cubic-bezier(0.645,0.045,0.355,1)",
  },
  variants: { cancel, blue, yellow, purple, red },
  sizes: {
    sm,
    normal,
    lg,
  },
  defaultProps: {
    colorScheme: "brand",
    size: "normal",
  },
});
